import React from 'react';
import Component from '@vfuk/core-spacing';
const Spacing = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default Spacing;
